import React from 'react';

import { useTailwindBreakpoint } from '@swyftx/aviary/hooks/useTailwindBreakpoint';

import { AppSideBar } from '@global-components/Navigation/components/AppSideBar';

import { UIStore } from '@shared/store';

import { observer } from 'mobx-react-lite';
import { AppFeature, useIsFeatureEnabled } from 'src/config';

import DesktopSidebar from './DekstopSidebar';
import MobileSidebar from './MobileSidebar/Index';
import { useAppSideBar } from './useAppSideBar';

// TODO remove these, currently used for Dynamic Grid calculations
export const DESKTOP_DRAWER_WIDTH = 240;
export const DESKTOP_DRAWER_WIDTH_CLOSED = 56;

const Navigation: React.FC = observer(() => {
  const { state, items, header, footer, onCloseAppBar } = useAppSideBar();
  const { isFeatureEnabled } = useIsFeatureEnabled();
  const { hideSideMenu } = UIStore.useUIStore;
  const isXs = useTailwindBreakpoint('xs');

  if (hideSideMenu) return null;

  // launchdarkly feature flag here

  return isFeatureEnabled(AppFeature.NewNavigationSideMenu) ? (
    isXs ? (
      // mobile, uses the desktop content inside
      <MobileSidebar />
    ) : (
      <DesktopSidebar />
    )
  ) : (
    <AppSideBar
      state={state}
      items={items}
      header={header}
      footer={footer}
      onClose={onCloseAppBar}
      itemsClassName='md:pb-96'
    />
  );
});

Navigation.displayName = 'Navigation';

export default Navigation;
